export default "__VITE_ASSET__8KSqTewq__"